import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { Form, Formik } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import { SubmitButton, TextField } from "../../components/formik";
import { updateExpert } from "../../ducks/actions";
import useActionRequest from "../../hooks/useActionRequest";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3)
  }
}));

const EditExpertDialog = ({ id, expert, onClose }) => {
  const intl = useIntl();
  const classes = useStyles();

  const updateExpertRequest = useActionRequest({
    action: updateExpert
  });

  const onUpdateExpert = async (expert, contextActions) => {
    const response = await updateExpertRequest({ id, expert });

    if (response.error) {
      /* eslint-disable no-debugger */
      debugger;
      contextActions.setSubmitting(false);
    } else onClose();
  };

  return (
    <Dialog open maxWidth="sm" fullWidth onClose={onClose}>
      <Typography variant="h5" className={classes.title}>
        <strong>
          {intl.formatMessage({
            id: "Experts.EditExpertDialog.EditExpertProfileInfo",
            defaultMessage: "Edit Expert Profile Info"
          })}
        </strong>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Typography>
      <Formik initialValues={expert} onSubmit={onUpdateExpert}>
        <Form>
          <DialogContent>
            <Typography variant="h5">General Infos</Typography>
            <Divider />
            <br />
            <TextField
              name="publicName"
              variant="outlined"
              label={intl.formatMessage({
                id: "Experts.EditExpertDialog.ExpertName",
                defaultMessage: "Name of the Expert"
              })}
              fullWidth
            />
            <TextField
              name="shortDescription"
              variant="outlined"
              label={intl.formatMessage({
                id: "Experts.EditExpertDialog.BriefDescription",
                defaultMessage: "Brief description"
              })}
              multiline
              rows={3}
              fullWidth
            />
            <TextField
              name="description"
              variant="outlined"
              label={intl.formatMessage({
                id: "Experts.EditExpertDialog.CompnayProfile",
                defaultMessage: "Expert's profile"
              })}
              multiline
              rows={3}
              fullWidth
            />
            <Typography variant="h5">Contacts</Typography>
            <Divider />
            <br />
            <TextField
              name="websiteUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Experts.EditExpertDialog.WebsiteURL",
                defaultMessage: "Website URL"
              })}
              fullWidth
            />
            <TextField
              name="linkedinUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Experts.EditExpertDialog.LinkedinURL",
                defaultMessage: "Linkedin URL"
              })}
              fullWidth
            />
            <TextField
              name="instagramUrl"
              variant="outlined"
              label={intl.formatMessage({
                id: "Experts.EditExpertDialog.InstagramURL",
                defaultMessage: "Instagram URL"
              })}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>
              {intl.formatMessage({
                id: "Experts.EditExpertDialog.Cancel",
                defaultMessage: "Cancel"
              })}
            </Button>
            <SubmitButton color="primary">
              {intl.formatMessage({
                id: "Experts.EditExpertDialog.Save",
                defaultMessage: "Save"
              })}
            </SubmitButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default EditExpertDialog;
